import React from "react";
import AdminSectionShell from "../components/AdminSectionShell";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";
import ViewDashboardOperacionalCotasSemPeriodos from "../views/ViewDashboardOperacionalCotasSemPeriodos";

const DashboardOperacionalCotasSemPeriodos: React.FC = () => {
  const { isLoading, isValid } = usePermissao("OPE");

  if (isLoading) {
    return <p>Verificando permissão...</p>;
  }

  if (!isValid) {
    return null;
  }

  return (
    <AdminSectionShell backTo="/dashboardOperacional">
      <ViewDashboardOperacionalCotasSemPeriodos />
    </AdminSectionShell>
  );
};

export default DashboardOperacionalCotasSemPeriodos;
